// extracted by mini-css-extract-plugin
export default {"elementsGroup":"ElementsGroup_elementsGroup__nXDCo","elementItem":"ElementsGroup_elementItem__OxKTg"};